import { Axios } from 'common/services';
import { IExpert, IHirer, IPageResult } from 'common/models';
import { UsageTireEnum } from 'common/enums';
import { UserRole } from 'common/types';

const getExperts = async (queryString: string): Promise<IPageResult<IExpert>> =>
  (await Axios.get(`/Admin/experts?${queryString}`)).data;

const getHirers = async (queryString: string): Promise<IPageResult<IHirer>> =>
  (await Axios.get(`/Admin/hirers?${queryString}`)).data;

const isProExpert = (expertSubscriptionType = UsageTireEnum.Free): boolean =>
  [UsageTireEnum.Pro, UsageTireEnum.ProPlus].includes(expertSubscriptionType);

const activateUser = async ({
  userId,
  role,
}: {
  userId: string;
  role: UserRole;
}) => await Axios.put(`/Admin/${role}s/activate?${userId}`);

const deactivateUser = async ({
  userId,
  role,
}: {
  userId: string;
  role: UserRole;
}) => await Axios.delete(`/Admin/${role}s/deactivate?${userId}`);

export default {
  activateUser,
  deactivateUser,
  getExperts,
  getHirers,
  isProExpert,
};
